"use client";

import type { ReactNode } from "react";
import { ConvexClientProvider } from "./convex-client-provider";

export function ConvexAuthenticatedShell({
  children,
  initialToken,
}: {
  readonly children: ReactNode;
  readonly initialToken?: string | null;
}): ReactNode {
  return (
    <ConvexClientProvider initialToken={initialToken}>
      {children}
    </ConvexClientProvider>
  );
}
